import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import axios from "axios";

function ReadingPage() {
  const { id } = useParams(); // book id from URL
  const [book, setBook] = useState(null);

  useEffect(() => {
    // Fetch book info
    axios.get(`/api/books/${id}`)
      .then((res) => setBook(res.data))
      .catch((err) => console.error("Failed to fetch book", err));
  }, [id]);

  if (!book) return <Typography>Loading book...</Typography>;

  return (
    <Box display="flex" height="100vh">
      <Box flex={1} borderRight="1px solid #ccc">
        <iframe
          src={`/api/books/pdf/${book._id}`}
          title="Book PDF"
          width="100%"
          height="100%"
          style={{ border: "none" }}
        />
      </Box>

      <Box flex={1} p={3} display="flex" flexDirection="column" alignItems="flex-start">
        <Box display="flex" gap={2} mb={3}>
          <Button variant="contained" color="primary">Popular</Button>
          <Button variant="contained" color="primary">Following</Button>
          <Button variant="contained" color="primary">Comment</Button>
          <Button variant="contained" color="primary">Communicate</Button>
          <Button variant="contained" color="primary">Generate Images</Button>
          <Button variant="contained" color="primary">Generate Video</Button>
        </Box>
      </Box>
    </Box>
  );
}

export default ReadingPage;
